import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartFooterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    actions: {
        alignItems: "center",
        flexDirection: "row",
        flexShrink: 0
    },
    note: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    spaces
}: ChartFooterDynamicStyleType) => {
    const styles = {
        actions: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
